import React, {
  useRef, useCallback, useState, useEffect,
} from 'react';
import Grid from '@material-ui/core/Grid';
import * as Yup from 'yup';
import getValidationError from '../../../utils/getValidationsErros';
import getCurrentPosition from '../../../utils/getCurrentPosition';
import Switch from '@material-ui/core/Switch';
import Modal from '../../../components/ModalSimple';
import colors from 'utils/colors';
import { FormHandles } from '@unform/core';
import { Form as UForm } from '@unform/web';
import { useHistory } from 'react-router-dom';
import { useAuth } from '../../../hooks/auth';
import { useHttp } from '../../../hooks/http';
import { fetchOrderDetail } from './apiCall';
import { withStyles, Theme, createStyles } from '@material-ui/core/styles';
import {  WrapperLabel, InputMask, Button, Input, Select } from '../../../components/Forms';
import {
  Container, GridButtons,
  WrapperBtnCancel, WrapperBtnSubmit,
  WrapperModal
} from './styles';
import { WarningIcon } from 'styles/icons';


interface IForm {
  coord: {
    lat: number,
    lng: number,
  }
}

const schema = Yup.object().shape({
  plate: Yup.string().test(
    'plate-or-chassi',
    'Informe a Placa ou o Chassi',
    function validate(value) {
      const { chassi } = this.parent;
      const cleanPlate = (value || '').replace(/[_\W]/g, '');
      const cleanChassi = (chassi || '').replace(/[_\W]/g, '');
      return cleanPlate.length > 0 || cleanChassi.length > 0;
    },
  ),
  chassi: Yup.string().test(
    'chassi-or-plate',
    'Informe o Chassi ou a Placa',
    function validate(value) {
      const { plate } = this.parent;
      const cleanPlate = (plate || '').replace(/[_\W]/g, '');
      const cleanChassi = (value || '').replace(/[_\W]/g, '');
      return cleanPlate.length > 0 || cleanChassi.length > 0;
    },
  ),
  brand: Yup.string().required('Marca/Modelo é obrigatório'),
  color: Yup.mixed().required('Cor é obrigatória').nullable(false),
  engine_number: Yup.string(),
});

const Vehicle: React.FC<IForm> = ({ coord }) => {
  const history = useHistory();
  const formRef = useRef<FormHandles>(null);
  const labelConfRef = useRef<HTMLLabelElement>(null);
  const { user } = useAuth();
  const { httpPost, httpGet } = useHttp();
  const [showMod, setShowMod] = useState<boolean>(false)
  const [formData, setFormData] = useState<any>();
  const [orderId, setOrderId] = useState<string | null>(null);
  const [btnLoading, setBtnLoading] = useState(false);
  const [newLoading, btnNewLoading] = useState(false);

  const modalOpenedRef = useRef(false);

  useEffect(() => {
    if (!orderId) return;
    modalOpenedRef.current = false;

    const interval = setInterval(async () => {
      const detail = await fetchOrderDetail(httpGet, orderId);
      if (detail?.id && !modalOpenedRef.current) {
        setFormData(detail);
        modalOpenedRef.current = true;
        labelConfRef.current?.click();
      }
      if (detail?.result_id) {
        setFormData(detail);
        clearInterval(interval);
        setOrderId(null);
      }
    }, 5000);

    return () => clearInterval(interval);
  }, [orderId, httpGet]);

  function handleGetVehicle(orderId: string) {
    btnNewLoading(true);
    history.push(`/order/detail/${orderId}`);
    btnNewLoading(false);
  };

  const handleSubmit = useCallback(async (data: any) => {
  
    const vehicle = {
      ...data,
      ...coord,
      management_id: user?.allocation?.management_id,
      plate: data.plate?.replace(/[_\W]/g, '').toUpperCase(),
      chassi: data.chassi?.replace(/[_\W]/g, '').toUpperCase(),
      engine_number: data.engine_number.replace(/\W/g, '').toUpperCase(),
      brand: data.brand.toUpperCase(),
      color: data.color?.value || null,
      type: 'vehicle',
    };

    try {
      formRef.current?.setErrors({});
      await schema.validate(data, { abortEarly: false });
      setBtnLoading(true);
      const position = await getCurrentPosition();

      const response: any = await httpPost('orders/nuint/vehicle', {
        ...vehicle,
        lat: position.lat,
        lng: position.lng,
      });

      if (response.status === 200) {
        const { data } = response;
        setOrderId(data.id);
      }

      if (response.status !== 200) {
        setBtnLoading(true);
      }
    } catch (err) {
      if (err instanceof Yup.ValidationError) {
        const erros = getValidationError(err);
        formRef.current?.setErrors(erros);
      }
      setBtnLoading(false);
    } 
  }, [coord, httpPost, user]);

  const toggleSwitch = useCallback(async () => {
    setShowMod(previousState => !previousState)
  }, [])

  return (
    <Container>
      <UForm ref={formRef} onSubmit={handleSubmit}>
        <Grid component="div" container justify='center' alignItems="center" spacing={1}>
          <Grid item>Placa</Grid>
          <Grid item>
            <AntSwitch checked={showMod} onChange={toggleSwitch} name="checkedC" />
          </Grid>
          <Grid item>Chassi</Grid>
        </Grid>
        <Grid container spacing={1}> 
          {!showMod ? (
            <WrapperLabel label="Placa" xs={12}>
              <InputMask
                name="plate"
                mask="aaa-9*99"
                style={{ textTransform: 'uppercase' }}
              />
            </WrapperLabel>
           ) : (
            <WrapperLabel label="Chassi" xs={12}>
              <InputMask
                name="chassi"
                mask=""
                style={{ textTransform: 'uppercase' }}
              />
            </WrapperLabel>
            )}
        </Grid>
        <Grid container spacing={1}>
          <WrapperLabel label="Motor" xs={12} sm={4}>
            <Input
              name="engine_number"
              style={{ textTransform: 'uppercase' }}
            />
          </WrapperLabel>
          <WrapperLabel label="Marca/Modelo" xs={12} sm={4}>
            <Input
              name="brand"
              style={{ textTransform: 'uppercase' }}
            />
          </WrapperLabel>
          <WrapperLabel label="Cor" xs={12} sm={4}>
            <Select
              name="color"
              transform="uppercase"
              options={colors}
            />
          </WrapperLabel>
        </Grid>
        <GridButtons>
          <WrapperBtnCancel>
            <Button
              type="button"
              onClick={() => { history.push('/dashboard'); }}
            >
              Cancelar
            </Button>
          </WrapperBtnCancel>
          <WrapperBtnSubmit>
            <Button
              type="button"
              onClick={() => {
                  formRef.current?.submitForm();
              }}
              disableForce={!! orderId}
              isLoading={btnLoading}
            >
              Consultar
            </Button>
          </WrapperBtnSubmit>
        </GridButtons>
      </UForm>
      <label ref={labelConfRef} htmlFor="modal-conf" style={{ opacity: 0 }} />
      <WrapperModal>
        <Modal id="modal-conf" width={520} height="auto" disableClose>
          {formData?.status !== 'Respondida' && (
            <div style={{ display: 'flex' }}>
              <h2><WarningIcon />{formData?.status}...</h2>
            </div>
          )}
          {formData?.plate && <p>Placa: <b>{formData.plate}</b></p>}
          {formData?.chassi && <p>Chassi: <b>{formData.chassi}</b></p>}
          {formData?.brand && <p>Marca/Modelo: <b>{formData.brand}</b></p>}
          {formData?.color && <p>Cor: <b>{formData.color}</b></p>}
          {formData?.status === 'Respondida' && (
            <span>
              <Button
                onClick={() => handleGetVehicle(formData.id)}
                isLoading={newLoading}
              >
                Avançar
              </Button>
            </span>
          )}
        </Modal>
      </WrapperModal>
    </Container>
  );
};

export default Vehicle;


const AntSwitch = withStyles((theme: Theme) =>
  createStyles({
    root: {
      width: 28,
      height: 16,
      padding: 0,
      display: 'flex',
    },
    switchBase: {
      padding: 2,
      color: theme.palette.info.dark,
      '&$checked': {
        transform: 'translateX(12px)',
        color: theme.palette.common.white,
        '& + $track': {
          opacity: 1,
          backgroundColor: theme.palette.primary.main,
          borderColor: theme.palette.primary.main,
        },
      },
    },
    thumb: {
      width: 12,
      height: 12,
      boxShadow: 'none',
    },
    track: {
      border: `1px solid ${theme.palette.grey[500]}`,
      borderRadius: 16 / 2,
      opacity: 1,
      backgroundColor: theme.palette.common.white,
    },
    checked: {},
  }),
)(Switch);

